(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name oqs.directive:oqsTopPanel
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="oqs">
   <file name="index.html">
   <oqs-top-panel></oqs-top-panel>
   </file>
   </example>
   *
   */
  angular
    .module('oqs')
    .directive('oqsTopPanel', oqsTopPanel);

  function oqsTopPanel() {
    return {
      restrict: 'E',
      scope: {
        logoUrl: '=oqsLogoUrl',
        logoLink: '=oqsLogoLink',
        titleMessageKey: '@oqsTitleMessageKey',
        brokerLogoUrl: '=oqsBrokerLogoUrl'
      },
      templateUrl: 'directives/oqs-top-panel-directive.tpl.html',
      replace: false,
      transclude: true,
      bindToController: true,
      controllerAs: 'oqsTopPanel',
      controller: OqsTopPanelController,
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }

  OqsTopPanelController.$inject = ['DataService'];

  function OqsTopPanelController(dataService) {
    var vm = this;
    vm.showDebug = false;
    vm.clearCache = clearCache;
    vm.isDevMode = isDevMode;
    vm.data = dataService.data;

    function clearCache() {
      dataService.clearCache();
    }

    function isDevMode() {
      if (dataService.data.quoteDefinition.sbuDetails.mode === 'DEV') {
        return true;
      }
      return false;
    }
  }
}());
